import React, { Component } from "react";
import { Link } from "react-router-dom";
import styles from "../../thema/style";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import FloatingWhatsApp from "../../components/FloatingWhatsApp";

// Trust badges component
const TrustBadges = ({ setting }) => {
  return (
    <div
      style={{
        background: "#ffffff",
        borderTop: "1px solid #e5e5e5",
        padding: "50px 0",
      }}
    >
      <div className="container">
        <div className="row">
          <div className="col-md-4 text-center">
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "15px",
              }}
            >
              <img
                src="/images/footer-shield-icon.svg"
                alt="SSL Güvenlik"
                height="100"
                style={{
                  filter:
                    "brightness(0) saturate(100%) invert(42%) sepia(0%) saturate(0%) hue-rotate(173deg) brightness(98%) contrast(88%)",
                }}
              />
              <div>
                <p
                  style={{
                    margin: 0,
                    fontSize: "14px",
                    color: "#333",
                    fontWeight: "400",
                    lineHeight: "1.5",
                  }}
                >
                  256 Bit SSL Güvenlik
                  <br />
                  Güvenli alışveriş garantisi
                </p>
              </div>
            </div>
          </div>

          <div className="col-md-4 text-center">
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "15px",
              }}
            >
              <img
                src="/images/footer-delivery-icon.svg"
                alt="Ücretsiz Kargo"
                height="100"
                style={{
                  filter:
                    "brightness(0) saturate(100%) invert(42%) sepia(0%) saturate(0%) hue-rotate(173deg) brightness(98%) contrast(88%)",
                }}
              />
              <div>
                <p
                  style={{
                    margin: 0,
                    fontSize: "14px",
                    color: "#333",
                    fontWeight: "400",
                    lineHeight: "1.5",
                  }}
                >
                  {setting && setting.free_shipping
                    ? setting.free_shipping
                    : "150"}{" "}
                  TL Üzeri Ücretsiz Kargo
                  <br />
                  Hızlı ve güvenilir teslimat
                </p>
              </div>
            </div>
          </div>

          <div className="col-md-4 text-center">
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "15px",
              }}
            >
              <img
                src="/images/footer-refund-icon.svg"
                alt="Kolay İade"
                height="100"
                style={{
                  filter:
                    "brightness(0) saturate(100%) invert(42%) sepia(0%) saturate(0%) hue-rotate(173deg) brightness(98%) contrast(88%)",
                }}
              />
              <div>
                <p
                  style={{
                    margin: 0,
                    fontSize: "14px",
                    color: "#333",
                    fontWeight: "400",
                    lineHeight: "1.5",
                  }}
                >
                  15 Gün Kolay İade
                  <br />
                  Koşulsuz iade hakkı
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

class Footer extends Component {
  render() {
    return (
      <React.Fragment>
        {this.props.setting.setting && this.props.setting.setting.wpTitle !== "" && (
          <FloatingWhatsApp
            title={this.props.setting.setting.wpTitle}
            content={this.props.setting.setting.wpContent}
            phoneNumber={this.props.setting.setting.wpPhone}
          />
        )}

        {/* Trust Badges Section */}
        {this.props.setting.setting && <TrustBadges setting={this.props.setting.setting} />}

        <footer style={{ background: "#1a1a1a" }}>
          {/* Main Footer */}
          <div
            style={{
              padding: "60px 0 40px 0",
              borderBottom: "1px solid rgba(255,255,255,0.08)",
            }}
          >
            <div className="container">
              <div className="row">
                {/* Company Info */}
                <div className="col-md-4">
                  <div
                    style={{
                      marginBottom: "25px",
                    }}
                  >
                    <img
                      src="/images/logo.png"
                      alt="Botaniksan Logo"
                      style={{
                        height: "45px",
                        width: "auto",
                      }}
                      onError={(e) => {
                        e.target.style.display = "none";
                        e.target.nextSibling.style.display = "block";
                      }}
                    />
                    <h3
                      style={{
                        color: "#fff",
                        fontSize: "22px",
                        fontWeight: "700",
                        letterSpacing: "0.5px",
                        margin: 0,
                        display: "none",
                      }}
                    >
                      BOTANIKSAN
                    </h3>
                  </div>
                  <p
                    style={{
                      color: "#999",
                      fontSize: "14px",
                      lineHeight: "1.8",
                      marginBottom: "25px",
                    }}
                  >
                    Botaniksan bitkisel market. %100 Doğal ve bitkisel ürünler;
                    bitkisel ve aromatik yağlar, bitkisel macunlar, kremlerden
                    her çeşit baharattan şifallı bitkilere kadar yüzlerce çeşit
                    ürün yelpazesine sahibiz.
                  </p>
                  {/* Social Media Icons */}
                  <div
                    style={{
                      marginTop: "20px",
                      display: "flex",
                      gap: "10px",
                    }}
                  >
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href={
                        this.props.setting.setting &&
                        this.props.setting.setting.facebook
                      }
                      style={{
                        width: "40px",
                        height: "40px",
                        borderRadius: "50%",
                        background: "#3b5998",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        transition: "transform 0.3s",
                      }}
                      onMouseEnter={(e) =>
                        (e.target.style.transform = "translateY(-3px)")
                      }
                      onMouseLeave={(e) =>
                        (e.target.style.transform = "translateY(0)")
                      }
                    >
                      <FontAwesomeIcon
                        icon={["fab", "facebook-f"]}
                        color="#fff"
                      />
                    </a>
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href={
                        this.props.setting.setting &&
                        this.props.setting.setting.instagram
                      }
                      style={{
                        width: "40px",
                        height: "40px",
                        borderRadius: "50%",
                        background:
                          "linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        transition: "transform 0.3s",
                      }}
                      onMouseEnter={(e) =>
                        (e.target.style.transform = "translateY(-3px)")
                      }
                      onMouseLeave={(e) =>
                        (e.target.style.transform = "translateY(0)")
                      }
                    >
                      <FontAwesomeIcon
                        icon={["fab", "instagram"]}
                        color="#fff"
                      />
                    </a>
                  </div>
                </div>

                {/* Quick Links */}
                <div className="col-md-2">
                  <h3
                    style={{
                      color: "#fff",
                      fontSize: "16px",
                      fontWeight: "600",
                      marginBottom: "25px",
                      textTransform: "uppercase",
                      letterSpacing: "0.5px",
                    }}
                  >
                    KURUMSAL
                  </h3>
                  <ul
                    style={{
                      listStyleType: "none",
                      listStyle: "none",
                      padding: 0,
                      margin: 0,
                      WebkitPaddingStart: 0,
                      MozPaddingStart: 0,
                    }}
                  >
                    {this.props.page.page &&
                      this.props.page.page.map(
                        (page, i) =>
                          page.location === "bottom_menu" && (
                            <li
                              key={i}
                              style={{
                                marginBottom: "12px",
                                listStyleType: "none",
                                position: "relative",
                              }}
                            >
                              <Link
                                to={{
                                  pathname: `/p/${page.slug}`,
                                  state: { page },
                                }}
                                style={{
                                  color: "#999",
                                  fontSize: "14px",
                                  textDecoration: "none",
                                  transition: "all 0.3s",
                                  display: "inline-block",
                                }}
                                onMouseEnter={(e) => {
                                  e.target.style.color = "#88c000";
                                  e.target.style.paddingLeft = "5px";
                                }}
                                onMouseLeave={(e) => {
                                  e.target.style.color = "#999";
                                  e.target.style.paddingLeft = "0";
                                }}
                              >
                                {page.menu_title}
                              </Link>
                            </li>
                          )
                      )}
                    <li
                      style={{
                        marginBottom: "12px",
                        listStyleType: "none",
                        position: "relative",
                      }}
                    >
                      <Link
                        to="/blog"
                        style={{
                          color: "#999",
                          fontSize: "14px",
                          textDecoration: "none",
                          transition: "all 0.3s",
                          display: "inline-block",
                        }}
                        onMouseEnter={(e) => {
                          e.target.style.color = "#88c000";
                          e.target.style.paddingLeft = "5px";
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.color = "#999";
                          e.target.style.paddingLeft = "0";
                        }}
                      >
                        Blog
                      </Link>
                    </li>
                  </ul>
                </div>

                {/* Categories */}
                <div className="col-md-3">
                  <h3
                    style={{
                      color: "#fff",
                      fontSize: "16px",
                      fontWeight: "600",
                      marginBottom: "25px",
                      textTransform: "uppercase",
                      letterSpacing: "0.5px",
                    }}
                  >
                    KATEGORİLER
                  </h3>
                  <ul
                    style={{
                      listStyleType: "none",
                      listStyle: "none",
                      padding: 0,
                      margin: 0,
                      WebkitPaddingStart: 0,
                      MozPaddingStart: 0,
                    }}
                  >
                    <li
                      style={{
                        marginBottom: "12px",
                        listStyleType: "none",
                        position: "relative",
                      }}
                    >
                      <Link
                        to="/category/bitkisel-yaglar"
                        style={{
                          color: "#999",
                          fontSize: "14px",
                          textDecoration: "none",
                          transition: "all 0.3s",
                          display: "inline-block",
                        }}
                        onMouseEnter={(e) => {
                          e.target.style.color = "#88c000";
                          e.target.style.paddingLeft = "5px";
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.color = "#999";
                          e.target.style.paddingLeft = "0";
                        }}
                      >
                        Bitkisel Yağlar
                      </Link>
                    </li>
                    <li
                      style={{
                        marginBottom: "12px",
                        listStyleType: "none",
                        position: "relative",
                      }}
                    >
                      <Link
                        to="/category/bitkisel-macunlar"
                        style={{
                          color: "#999",
                          fontSize: "14px",
                          textDecoration: "none",
                          transition: "all 0.3s",
                          display: "inline-block",
                        }}
                        onMouseEnter={(e) => {
                          e.target.style.color = "#88c000";
                          e.target.style.paddingLeft = "5px";
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.color = "#999";
                          e.target.style.paddingLeft = "0";
                        }}
                      >
                        Bitkisel Macunlar
                      </Link>
                    </li>
                    <li
                      style={{
                        marginBottom: "12px",
                        listStyleType: "none",
                        position: "relative",
                      }}
                    >
                      <Link
                        to="/category/bitkisel-sabunlar"
                        style={{
                          color: "#999",
                          fontSize: "14px",
                          textDecoration: "none",
                          transition: "all 0.3s",
                          display: "inline-block",
                        }}
                        onMouseEnter={(e) => {
                          e.target.style.color = "#88c000";
                          e.target.style.paddingLeft = "5px";
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.color = "#999";
                          e.target.style.paddingLeft = "0";
                        }}
                      >
                        Bitkisel Sabunlar
                      </Link>
                    </li>
                    <li
                      style={{
                        marginBottom: "12px",
                        listStyleType: "none",
                        position: "relative",
                      }}
                    >
                      <Link
                        to="/category/bitkisel-sampuanlar"
                        style={{
                          color: "#999",
                          fontSize: "14px",
                          textDecoration: "none",
                          transition: "all 0.3s",
                          display: "inline-block",
                        }}
                        onMouseEnter={(e) => {
                          e.target.style.color = "#88c000";
                          e.target.style.paddingLeft = "5px";
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.color = "#999";
                          e.target.style.paddingLeft = "0";
                        }}
                      >
                        Bitkisel Şampuanlar
                      </Link>
                    </li>
                  </ul>
                </div>

                {/* Contact Info */}
                <div className="col-md-3">
                  <h3
                    style={{
                      color: "#fff",
                      fontSize: "16px",
                      fontWeight: "600",
                      marginBottom: "25px",
                      textTransform: "uppercase",
                      letterSpacing: "0.5px",
                    }}
                  >
                    İLETİŞİM
                  </h3>
                  <ul
                    style={{
                      listStyleType: "none",
                      listStyle: "none",
                      padding: 0,
                      margin: 0,
                      WebkitPaddingStart: 0,
                      MozPaddingStart: 0,
                    }}
                  >
                    <li
                      style={{
                        marginBottom: "15px",
                        display: "flex",
                        alignItems: "flex-start",
                        gap: "10px",
                      }}
                    >
                      <FontAwesomeIcon
                        icon={["fas", "map-marker-alt"]}
                        color="#88c000"
                        style={{ marginTop: "3px" }}
                      />
                      <span
                        style={{
                          color: "#bdc3c7",
                          fontSize: "14px",
                          lineHeight: "1.6",
                        }}
                      >
                        {this.props.setting.setting &&
                          this.props.setting.setting.footer_address}
                      </span>
                    </li>
                    <li
                      style={{
                        marginBottom: "15px",
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                      <FontAwesomeIcon
                        icon={["fas", "phone"]}
                        color="#88c000"
                      />
                      <a
                        href={`tel:${
                          this.props.setting.setting &&
                          this.props.setting.setting.footer_phone
                        }`}
                        style={{
                          color: "#bdc3c7",
                          fontSize: "14px",
                          textDecoration: "none",
                          transition: "color 0.3s",
                        }}
                        onMouseEnter={(e) => (e.target.style.color = "#88c000")}
                        onMouseLeave={(e) => (e.target.style.color = "#bdc3c7")}
                      >
                        {this.props.setting.setting &&
                          this.props.setting.setting.footer_phone}
                      </a>
                    </li>
                    <li
                      style={{
                        marginBottom: "15px",
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                      <FontAwesomeIcon
                        icon={["fas", "envelope"]}
                        color="#88c000"
                      />
                      <a
                        href={`mailto:${
                          this.props.setting.setting &&
                          this.props.setting.setting.footer_mail
                        }`}
                        style={{
                          color: "#bdc3c7",
                          fontSize: "14px",
                          textDecoration: "none",
                          transition: "color 0.3s",
                        }}
                        onMouseEnter={(e) => (e.target.style.color = "#88c000")}
                        onMouseLeave={(e) => (e.target.style.color = "#bdc3c7")}
                      >
                        {this.props.setting.setting &&
                          this.props.setting.setting.footer_mail}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          {/* Bottom Footer */}
          <div
            style={{
              background: "#0f0f0f",
              padding: "20px 0",
            }}
          >
            <div className="container">
              <div className="row">
                <div className="col-md-6">
                  <p
                    style={{
                      margin: 0,
                      color: "#95a5a6",
                      fontSize: "13px",
                    }}
                  >
                    {this.props.setting.setting &&
                      this.props.setting.setting.copyright}
                  </p>
                </div>
                <div className="col-md-6 text-right">
                  <p
                    style={{
                      margin: 0,
                      color: "#95a5a6",
                      fontSize: "13px",
                    }}
                  >
                    Tasarım ve Yazılım{" "}
                    <a
                      href="http://swbilisim.com"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        color: "#88c000",
                        textDecoration: "none",
                        fontWeight: "600",
                      }}
                    >
                      SW Bilişim
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </footer>
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ setting, page }) => {
  return { setting, page };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Footer);



// WEBPACK FOOTER //
// ./src/components/shared/Footer.js